import React from "react";
import { View } from "react-native";

export default class ReadonlyView extends React.Component {
    render() {
        const { readonly, children, ...props } = this.props;
        return(
            <View {...props}>
                {children}
                {readonly ?
                 (<View style={{position: 'absolute', left: 0, top: 0, right: 0, bottom: 0, zIndex: 1}}/>) : null}
            </View>
        )
    }
}
